import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { connect } from "react-redux";
import { Api, Color } from "services";
import { useHistory } from "react-router-dom";
import ReactPlayer from "react-player";
import {
  ArrowLeftOutlined,
  EditFilled,
  DeleteFilled,
  ExclamationCircleOutlined,
  CopyFilled,
  DownloadOutlined,
} from "@ant-design/icons";
import {
  currentDocument,
  currentTypes,
  deleteNotes,
  fetchAdminLibraryData,
  removemodel,
  setEditObject,
  setUploadContent,
  updateDocumentInfo,
  IsHSL
} from "../../../actions/digitalLibrary";
import EditInformation from "../modals/editInformation";
import CloneInformation from "../modals/cloneInformation";
import DeleteConfirm from "../modals/deleteConfirm";
import YTPlayer from "components/ytPlayer";
import Axios from 'axios'
import fileDownload from 'js-file-download'
import ReactPlayerHoc from "components/ReactPlayerHoc";

const { confirm } = Modal;

function Viewpdf({
  file, filePath, fileLink,
  currentfiletoshow,
  currentId,
  currentDocument,
  deleteNotes,
  fetchAdminLibraryData,
  currentType,
  currentTypes,
  removemodel,
  user,
  documentInfo,
  updateDocumentInfo,
  setEditObject,
  setUploadContent,
  isHSL
}) {
  const history = useHistory();
  const [isVisibl, setIsModalVisibl] = useState(false);
  const [cloneModal, setCloneModal] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [modal, setmodal] = useState(false);
  const [linkPath, setLinlkPath] = useState('');
  const [remainingUrls, setRemainingUrls] = useState([]);
  removemodel();

  const handleHistory = () => {
    updateDocumentInfo({});
    currentDocument(0);
    setEditObject({});
    setUploadContent({});
    IsHSL(false)
    history.goBack();
  };

  const handleDeletenotes = (id) => {
    // return confirm({
    //     title: `Do you want to delete the content?`,
    //     icon: <ExclamationCircleOutlined />,
    //     content: 'Please click OK to confirm',
    //     onOk() {deleteNotes(id,false)
    //       history.goBack()

    //     },
    //     onCancel() {},
    //   })
    setIsDeleteModal(true);
  };
  useEffect(() => {
    console.log('isHSL', filePath, fileLink);

    const buildVideoPlaybackUrls = (rawPath) => {
      if (/^https?:/i.test(rawPath)) return rawPath;
      const dot = rawPath.lastIndexOf(".");
      const hasExt = dot > rawPath.lastIndexOf("/");
      const base = hasExt ? rawPath.slice(0, dot) : rawPath;
      const ext = hasExt ? rawPath.slice(dot + 1).toLowerCase() : "";
      const playableAsUploaded = ["mp4", "m4v", "webm", "ogg", "ogv", "mov", "m3u8"].includes(ext);
      const transcodedPlaylists = [
        `${Api.hlsUrl}${base}.m3u8`,
        `${Api.hlsUrl}${base}/master.m3u8`
      ];
      return playableAsUploaded
        ? [`${Api.hlsUrl}${rawPath}`, ...transcodedPlaylists, `${Api.dlS3Url}${rawPath}`]
        : [...transcodedPlaylists, `${Api.hlsUrl}${rawPath}`, `${Api.dlS3Url}${rawPath}`];
    };

    const isVideo = filePath && /\.(mp4|webm|ogg|mov|m4v|avi|wmv|flv|mkv)(\?.*)?$/i.test(filePath);

    if (isHSL || isVideo) {
      const urls = filePath ? buildVideoPlaybackUrls(filePath) : (fileLink ? [fileLink] : []);
      if (urls.length > 0) {
        setLinlkPath(urls[0]);
        setRemainingUrls(urls.slice(1));
      } else {
        setLinlkPath("");
        setRemainingUrls([]);
      }
    }
    else {
      setLinlkPath(filePath ? (filePath.startsWith('http') ? filePath : `${Api.dlS3Url}${filePath}`) : fileLink ? fileLink : "")
      setRemainingUrls([]);
    }
  }, [isHSL, filePath, fileLink])

  const handlePlaybackError = (error) => {
    if (!remainingUrls.length) return;
    const [next, ...rest] = remainingUrls;
    setLinlkPath(next);
    setRemainingUrls(rest);
  };

  const handleDownload = (file, name, type) => {
    console.log("name", name)
    Axios
      .get(`${Api.dlS3Url}${file}`, {
        responseType: "blob",
      })
      .then((res) => {
        if (res.data) {
          fileDownload(res.data, `${name}.${type == "video" ? "video" : "pdf"}`);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };


  // YouTube URL regex
  const youtubeRegExp = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+$/i;
  // General video URL regex (matches .mp4, .webm, .ogg, etc.)
  const videoRegExp = /\.(mp4|webm|ogg|mov|m4v|avi|wmv|flv|mkv)(\?.*)?$/i;
  // Google Drive video regex
  const driveRegExp = /drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)\//i;

  // Function to extract the video ID from a Google Drive URL
  const getIframeSrc = (url) => {
    const match = url.match(/\/d\/(.+?)\//);
    if (match && match[1]) {
      return `https://drive.google.com/file/d/${match[1]}/preview`;
    }
    return null;
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <div
        style={{
          width: "100%",
          height: "5%",
          marginBottom: "5px",
          background: "",
          justifyContent: "space-between",
          display: "flex",
          paddingLeft: "5px",
          paddingRight: "5px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ArrowLeftOutlined
            style={{ fontSize: "150% ", color: "#636363" }}
            onClick={() => handleHistory()}
          />
        </div>
        {user.access.includes("digital-library-admin") ||
          user.access.includes("digital-library-superadmin") ||
          user.access.includes("digital-library-dataoperator") ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <EditFilled style={{ fontSize: "150% ", color: "#636363" }} />
            <div
              className="cursor-pointer"
              style={{
                marginRight: "20px",
                marginLeft: "5px",
                fontSize: "14px",
                color: "#636363",
                font: "normal normal normal 14px/16px Roboto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={() => setIsModalVisibl(true)}
            >
              {" "}
              Edit
            </div>
            {isVisibl && (
              <EditInformation
                ismodelvisible={isVisibl}
                setmodevisible={setIsModalVisibl}
                id={currentId}
                setmodal={setmodal}
                types={currentType}
                title={documentInfo.title}
              />
            )}

            <CopyFilled style={{ fontSize: "150% ", color: "#636363" }} />
            <div
              className="cursor-pointer"
              style={{
                marginRight: "20px",
                marginLeft: "5px",
                fontSize: "14px",
                color: "#636363",
                font: "normal normal normal 14px/16px Roboto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={() => setCloneModal(true)}
            >
              Clone
            </div>
            {cloneModal && (
              <CloneInformation
                ismodelvisible={cloneModal}
                setmodevisible={setCloneModal}
                id={currentId}
                setmodal={setmodal}
                types={currentType}
                title={documentInfo.title}
              />
            )}

            <DeleteFilled style={{ fontSize: "150% ", color: "#636363" }} />
            <div
              className="cursor-pointer"
              style={{
                marginRight: "20px",
                marginLeft: "5px",
                fontSize: "14px",
                color: "#636363",
                font: "normal normal normal 14px/16px Roboto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={() => handleDeletenotes()}
            >
              Delete
            </div>
            {(documentInfo?.status == 'Published' && documentInfo?.file && (user.access.includes('digital-library-admin') || user.access.includes('digital-library-superadmin'))) &&
              <>
                <DownloadOutlined style={{ fontSize: "150% ", color: "#636363" }} />
                <div
                  className="cursor-pointer"
                  style={{
                    marginRight: "20px",
                    marginLeft: "5px",
                    fontSize: "14px",
                    color: "#636363",
                    font: "normal normal normal 14px/16px Roboto",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => handleDownload(documentInfo?.file, documentInfo?.title, documentInfo?.type)}
                >
                  Download
                </div>
              </>}
          </div>
        ) : null}
        {isDeleteModal && (
          <DeleteConfirm
            isModalVisible={isDeleteModal}
            setModalVisible={setIsDeleteModal}
            id={currentId}
            notes={true}
            history={history}
          />
        )}
      </div>
      {console.log("currentfiletoshow", currentfiletoshow, linkPath)}
      {currentfiletoshow == 'link' ? (
        <div
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            padding: "50px"
          }}
        >

          {console.log('linkPath', linkPath, typeof linkPath === 'string' && linkPath.match(youtubeRegExp), typeof linkPath === 'string' && (linkPath.match(videoRegExp)))}
          {
            typeof linkPath === 'string' && linkPath.match(youtubeRegExp) ? (
              <YTPlayer keyboardControls={true} videoUrl={linkPath} />
            ) : typeof linkPath === 'string' && linkPath.match(driveRegExp) && getIframeSrc(linkPath) ? (
              <iframe
                src={getIframeSrc(linkPath)}
                width="640"
                height="480"
                allow="autoplay"
                allowFullScreen
                style={{ marginTop: 30 }}
                title="Google Drive Video"
              ></iframe>
            ) : linkPath && (typeof linkPath !== 'string' || linkPath.match(videoRegExp)) ? (
              <ReactPlayer
                style={{ marginTop: 30 }}
                height={"70%"}
                width={"90%"}
                url={linkPath}
                controls={true}
                onError={handlePlaybackError}
              />
            ) : null
          }


          {/* {
            linkPath && linkPath.match(youtubeRegExp) ?
              <YTPlayer keyboardControls={true} videoUrl={linkPath} />
              : linkPath && (linkPath.match(videoRegExp)) ?
                <ReactPlayer
                  style={{ marginTop: 30 }}
                  height={"70%"}
                  width={"90%"}
                  // config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                  // onContextMenu={e => e.preventDefault()}
                  url={linkPath}
                  controls={true}
                />
                : null
          } */}
          {/* <ReactPlayer
            style={{ marginTop: 30 }}
            height={"70%"}
            width={"90%"}
            config={{ file: { attributes: { controlsList: 'nodownload' } } }}
            onContextMenu={e => e.preventDefault()}
            url={linkPath}
            controls={true}
          /> */}
          {/* <YTPlayer videoUrl={linkPath} keyboardControls={true} /> */}
        </div>
      ) :
        (documentInfo?.type == 'lecture-notes' || currentfiletoshow == 'pdf') ?
          (
            <div style={{ height: "100%", width: "100%" }}>
              <iframe
                width="100%"
                height="100%"
                src={`${Api.dlS3Url}${file}#toolbar=0`}
                frameborder="0"
              ></iframe>
            </div>
          ) :
          (
            <div style={{ height: "100%", width: "100%", }}>
              <ReactPlayerHoc
                style={{ marginTop: 30 }}
                height={"70%"}
                width={"90%"}
                config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                onContextMenu={e => e.preventDefault()}
                url={linkPath}
                controls={true}
                // contentId={currentId}
                keyboardControls={true}
                onError={handlePlaybackError}
              // moduleType={'DIGITALLIBRARY'}
              />
            </div>
          )
      }
    </div>
  );
}

const mapStateToProps = (state) => {
  const { file, currentfiletoshow, currentId, currentType, documentInfo, isHSL, filePath, fileLink } =
    state.digitalLibrary;
  const { user } = state.session;
  return {
    file,
    currentfiletoshow,
    currentId,
    currentType,
    user,
    documentInfo,
    isHSL,
    filePath, fileLink
  };
};

const mapDispatchToProps = (dispatch) => ({
  deleteNotes: (id, fetch) => dispatch(deleteNotes(id, fetch)),
  currentDocument: (id) => dispatch(currentDocument(id)),
  currentTypes: (type) => dispatch(currentTypes(type)),
  fetchAdminLibraryData: () => dispatch(fetchAdminLibraryData()),
  removemodel: () => dispatch(removemodel()),
  updateDocumentInfo: (data) => dispatch(updateDocumentInfo(data)),
  setEditObject: (object) => dispatch(setEditObject(object)),
  setUploadContent: (object) => dispatch(setUploadContent(object)),
  IsHSL: (bool) => dispatch(IsHSL(bool))
});

export default connect(mapStateToProps, mapDispatchToProps)(Viewpdf);
